import { ShoppingCartIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

export default function OpenCart({
  className,
  quantity
}: {
  className?: string;
  quantity?: number;
}) {
  return (
    <div className="relative flex size-6 items-center justify-center rounded-md text-black transition-colors  dark:text-white">
      <ShoppingCartIcon
        className={clsx('h-6 transition-all ease-in-out hover:scale-110', className)}
      />

      {quantity ? (
        <div className="absolute right-0 top-0 -mr-2 -mt-2 h-4 w-4 rounded bg-fp-green text-[11px] font-medium text-white">
          {quantity}
        </div>
      ) : null}
    </div>
  );
}
